import { render } from "./PigTypePicker.vue?vue&type=template&id=0ee6b8d0&ts=true"
import script from "./PigTypePicker.vue?vue&type=script&lang=ts"
export * from "./PigTypePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__